import styled from '@emotion/styled';
export const Wrapper = styled('figure') `
  height: 100%;
  position: relative;
  width: 100%;
  margin: 0;

  &:hover .fw-meta {
    background-image: linear-gradient(
      to bottom,
      transparent,
      rgb(0 0 0 / 100%)
    );
  }
`;
export const Badge = styled('span') `
  position: absolute;
  right: 5px;
  top: 5px;
`;
export const Meta = styled.div `
  background-image: linear-gradient(
    to bottom,
    transparent,
    rgb(0 0 0/ 46%),
    rgb(0 0 0 / 80%)
  );
  background-size: 100%
    ${({ isCaptionHidden }) => (isCaptionHidden ? '0%' : '100%')};
  background-position: center bottom;
  background-repeat: no-repeat;
  bottom: 0;
  font-size: ${({ padding }) => padding
    ? Math.max(1.2 * padding, 16) // Calculate font size for responsive grid (padding is 7% of smallest dimension)
    : 16}px !important;
  font-weight: 600 !important;
  left: 0;
  margin: 0;
  min-height: 50%;
  position: absolute;
  width: 100%;
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${({ padding }) => padding}px;
  padding: ${({ padding }) => padding}px;
`;
export const Caption = styled.figcaption `
  color: #fff;
  margin: 0;
  opacity: ${({ isCaptionHidden }) => (isCaptionHidden ? '0' : '1')};
  padding: 0;
  text-overflow: ellipsis;
  text-shadow: 0 0 4px rgb(0 0 0 / 80%);
  transition: opacity 0.3s;

  font-size: var(--thumbnail-font-size, inherit);
  font-weight: var(--thumbnail-font-weight, inherit);

  /* Line-clamping */
  display: block;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  overflow: hidden;

  /* hyphenation */
  -webkit-hyphens: auto;
  hyphens: auto;
`;
export const HeaderWrapper = styled.div `
  top: 0;
  right: 0;
  position: absolute;
  z-index: 2;
  padding: ${({ padding }) => padding}px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const LockWrapper = styled('div') `
  border-radius: 23px;
  width: 40px;
  height: 40px;
  background: rgb(var(--gray3-rgb) / 50%);
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    margin-bottom: 0;
  }
`;
export const MuteButtonWrapper = styled.div `
  position: absolute;
  z-index: 2;
  padding: 8px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  top: 0;
  right: 0;
`;
